<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-laptop`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 8a2 2 0 00-2-2H6a2 2 0 00-2 2v26a2 2 0 002 2h36a2 2 0 002-2V8zm2 31a1 1 0 00-1-1H3a1 1 0 00-1 1v2a1 1 0 001 1h42a1 1 0 001-1v-2zm-6-29H8v22h32V10zm-14 4a2 2 0 10-4 0 2 2 0 004 0z"/></svg>
</template>
<script>

export default {
  name: 'IconLaptop',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
